// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608312344/js/" + chunkId + "." + {"44":"a63f38dc","225":"352a8a7b","481":"aea407d8","486":"2c5fd6ef","770":"260a76bb"}[chunkId] + ".0.7653226407961553.chunk.js";
};